import React from "react";
import { useSelector } from "react-redux";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { useHistory } from "react-router";

import { SettingsModal } from "src/app/SettingsModal/SettingsModal";
import { AppLocation } from "src/redux/main/mainReducer";
import { RootState } from "src/redux/reducers";
import { SettingsContext, SettingsTab } from "src/app/SettingsModal/enums";
import { openSettingsModal } from "src/app/SettingsModal/methods";
import { WarningModal } from "../../WarningModal/WarningModal";

interface CreateNewProjectPaneModalsProps {
  showWarningModal: boolean;
  hidePane: () => void;
  setShowWarningModal: (val: boolean) => void;
}

export default function CreateNewProjectPaneModals({
  showWarningModal,
  hidePane,
  setShowWarningModal,
}: CreateNewProjectPaneModalsProps) {
  const { settingsModalData, identity } = useSelector(
    (state: RootState) => state.mainReducer,
  );

  const history = useHistory();
  return (
    <>
      {settingsModalData?.location === AppLocation.CreateNewProject && (
        <SettingsModal
          members={{
            openShareModal: () =>
              openSettingsModal(
                history,
                AppLocation.CreateNewProject,
                SettingsContext.Project,
                SettingsTab.Members,
              ),
          }}
          contextTargetUuid={identity?.lastWorkspaceUuid}
          disableTransition
        />
      )}
      {showWarningModal && (
        <WarningModal
          onClose={() => setShowWarningModal(false)}
          confirmAction={hidePane}
          upperText={
            <IDHFormattedMessage
              id="ws_outside_click_warning_modal_text"
              defaultMessage="Unsaved data could be lost"
            />
          }
          warningMessage={
            <IDHFormattedMessage
              id="ws_outside_click_warning_modal_warning"
              defaultMessage="Make sure you don't lose any data."
            />
          }
        />
      )}
    </>
  );
}
